<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-swap-alt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 31.25a1 1 0 001 1l22.075.001V38.4a.6.6 0 00.968.473l11.43-8.894a.999.999 0 00.248-.283.998.998 0 00-.716-1.696H7a1 1 0 00-1 1v2.25zm.18-11.67a1 1 0 00.814.42h34.004a1 1 0 001-1v-2.25a1 1 0 00-1-1l-22.075-.001.001-6.149a.6.6 0 00-.968-.473L6.526 18.02a.996.996 0 00-.25.283.998.998 0 00-.097 1.276z"/></svg>
</template>
<script>

export default {
  name: 'IconSwapAlt',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
